import React, { useMemo, useRef, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { CrmButton } from '../../ui';

// knownItems (optional): a wider list (e.g. including inactive entries) used only to name selected values that
// are not among the pickable options, so they stay visible and removable instead of being silently kept.
export default function EntityMultiPicker({ label, options = [], value = [], onChange, disabled = false, helperText, onCreate, createLabel = 'Create', placeholder = 'Type to search…', knownItems = [] }) {
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const ids = (Array.isArray(value) ? value : []).map((item) => String(item)).filter(Boolean);
  const selected = ids.map((id) => {
    const option = options.find((item) => String(item.id) === id);
    if (option || !knownItems.length) return option;
    const known = knownItems.find((item) => String(item.id) === id);
    return { id, name: `${known?.name || `#${id}`} (inactive)` };
  }).filter(Boolean);
  const filtered = useMemo(() => options
    .filter((item) => !ids.includes(String(item.id)))
    .filter((item) => String(item.name || item.label || item.display_name || '').toLowerCase().includes(query.toLowerCase()))
    .slice(0, 30), [options, ids, query]);

  const add = (item) => {
    onChange([...ids, String(item.id)]);
    setQuery('');
    setOpen(true);
  };
  const remove = (itemId) => onChange(ids.filter((id) => String(id) !== String(itemId)));

  return <div className="product-entity-picker" ref={rootRef}>
    <div className="product-entity-picker__label-row">
      <span>{label}</span>
      {onCreate ? <CrmButton size="small" variant="tertiary" startIcon={<AddIcon fontSize="small" />} onClick={onCreate} disabled={disabled}>{createLabel}</CrmButton> : null}
    </div>
    <div className={`product-typeahead ${disabled ? 'is-disabled' : ''}`}>
      <div className="product-typeahead__control">
        <div className="product-typeahead__input-wrap">
          <SearchIcon fontSize="small" />
          <input
            type="text"
            value={query}
            disabled={disabled}
            placeholder={selected.length ? 'Add another…' : placeholder}
            onFocus={() => setOpen(true)}
            onBlur={() => setTimeout(() => setOpen(false), 120)}
            onChange={(event) => { setQuery(event.target.value); setOpen(true); }}
          />
          {query ? <button type="button" className="product-typeahead__clear" onMouseDown={(event) => event.preventDefault()} onClick={() => setQuery('')} aria-label="Clear search"><CloseIcon fontSize="inherit" /></button> : null}
        </div>
      </div>
      {open && !disabled ? <div className="product-typeahead__menu">
        {filtered.map((item) => <button type="button" key={item.id} onMouseDown={(event) => event.preventDefault()} onClick={() => add(item)}>{item.name || item.label || item.display_name}</button>)}
        {!filtered.length ? <div className="product-typeahead__empty">No matching options.</div> : null}
      </div> : null}
    </div>
    {selected.length ? <div className="product-entity-picker__chips product-entity-picker__chips--selected">
      {selected.map((item) => <span className="product-entity-chip" key={item.id}>{item.name || item.label || item.display_name}<button type="button" disabled={disabled} onClick={() => remove(item.id)} aria-label={`Remove ${item.name || item.label}`}><CloseIcon fontSize="inherit" /></button></span>)}
    </div> : null}
    {helperText ? <small className="product-editor-note">{helperText}</small> : null}
  </div>;
}
